import Image from "next/image";
import Link from "next/link";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
// import IFSform from "./ifs-interview-form";
import styles from "../upsc-interview/upsc-interview.module.css";
import IFSinterview from "../../assets/images/upsc/interview/IFS interview.png";
import Head from "next/head";

const ifsInterview2023 = () =>{

    const prelimlist =[
        {list:"102 out of 147 selections in IFS 2023 are from Shankar IAS Academy."},
        {list:"Among top 10 ranks 8 candidates are Student of Shankar IAS Academy."},
        {list:"9 Candidates from Tamil Nadu have cleared the Exam."},
        //{list:"9 Rank holders are women among the 52 selections from Shankar IAS Academy."},
      ]

      const jsonLd ={
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "UPSC IFS Interview Registration | Shankar IAS Academy",
        "url": "https://www.shankariasacademy.com/ifs-interview/",
        "Image":
        "https://www.shankariasacademy.com/_next/static/media/IFS%20interview.ef2606e6.png",
        "description": "UPSC IFS Interview Registration open! Prepare with expert guidance and secure your dream position. Don't wait, register now for personalized support!"
      }

    return(
        <>
            <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>UPSC IFS Interview Registration | Shankar IAS Academy</title>
                <meta name="title" content="UPSC IFS Interview Registration | Shankar IAS Academy" />
                <meta name="description" content="UPSC IFS Interview Registration open! Prepare with expert guidance and secure your dream position. Don't wait, register now for personalized support!" />
                <link rel="canonical" href="https://www.shankariasacademy.com/ifs-interview/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="UPSC IFS Interview Registration | Shankar IAS Academy" />
                <meta property="og:description" content="UPSC IFS Interview Registration open! Prepare with expert guidance and secure your dream position. Don't wait, register now for personalized support!" />
                <meta property="og:url" content="https://www.shankariasacademy.com/ifs-interview/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>    

            <Navbar title="IFS-Interview-2025" />

        <div className="container">

        <div className="row">
        <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>UPSC IFS(Forestry) Interview Guidance Programme 2025</h1>
        </div>
        </div>

        <div className={`${styles.bgbox} row`}>
            <div className="col p-2">
                        <Image
                        src={IFSinterview}
                        className="img-fluid w-100"
                        alt="IFS interview Banner"
                        title="UPSC IFS(Forestry) Interview Guidance Programme 2025"
                        />
            </div>
            <div className="d-flex justify-content-center py-3 py-md-5">
                <Link href="https://admissionsv1.shankariasacademy.com/forestry/" target="_blank" className={`${styles.btnbox}`}>
                <p className="pt-3">UPSC IFS (Forestry Service)<br/>Interview Registration 2025</p>
                <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
                </Link>
            </div>
        </div>

        </div>
        
        {/* <IFSform /> */}

        <div className="container pt-3 pt-md-4">

            <div className="row">
                <div className="col">
                    <h2 className={`${styles.contactheader}`}>SHANKAR IAS ACADEMY EDGE!</h2>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-md-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>Individual personalised<br />one-on-one session.</p>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>Mock interviews by<br />eminent panelists,<br />serving bureaucrats.</p>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>Group based<br />DAF profiling.</p>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-3 pt-lg-3 pt-xl-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>and much more...</p>
                    </div>
                </div>
            </div>

            <div className="row pt-4 pt-md-5">
                <div className="col">
                    <p className={`${styles.sectionsubtitle} mb-0`}>OUR ACHIEVEMENTS - 2023 INTERVIEW</p>

                        <ul className={`${styles.ulclass} ps-1 pt-2`}>
                            {prelimlist.map((item,index)=>(
                                  <li
                                    className={`${styles.ulliclass} ${styles.acheiverrank}`}
                                    id={styles.acheiverrankspecial} key={index}
                                  >
                                    <div className="d-inline">
                                      <p className={`${styles.ullispan} d-inline`}>
                                        {item.list}
                                      </p>
                                    </div>
                                  </li>
                              ))}
                        </ul>

                    <h2 className={`${styles.contactheader} mb-0`}>SIA Produces toppers from Tamilnadu for IFS for the 11th consecutive year.</h2>
                </div>
            </div>

        </div>

        <Footer />
        </>
    )
}
export default ifsInterview2023